<template lang="pug">

	b-modal(:hide-footer="true" :hide-header="false" title="Добавление участника" centered id='addExtraParticipantModal')

		b-tabs(pills card v-model="tabIndex")

			b-tab(title='Добавить существующий аккаунт')
				p.text-muted
					| Чтобы проверить существует ли пользователь в системе введите его email
					|
					b.text-dark полностью
					|
					| в поле ниже
				div
					b-form-input.my-3(v-model='searchStr' placeholder='Введите email пользователя')
					div(v-if='!account.users.isFetching && !timerLoading && searchStr!==""')

						div(v-if="filteredUsers.length")
							div
								| По этому email найден пользователь:
								| {{ filteredUsers[0].email }}

							b-alert.mt-3(v-if="_event.extra_data.length" show variant="warning") Чтобы добавить пользователя в группу выберите параметры его участия в форме ниже

							FormPpnt( :_event="_event" :_cbOK="cbOK" :_cbERR="()=>{}" :_htmlFormModel="_event.use_price ? regFormModel : []" :_userID="filteredUsers[0] ? filteredUsers[0].id : null" :_ppntID="myParticipant.data.id")

						div.g-between-center(v-if="!filteredUsers.length")
							| пользователя с таким email не найдено
							b-button.ml-2(size="sm" variant="primary" style="flex: 0 0 auto;" @click="tabIndex=1") создать аккаунт

					div.text-center(v-if='account.users.isFetching && searchStr!==""')
						b-spinner(small label="Small Spinning")

			b-tab(title='Создать аккаунт')
				createAccountTab(:_setTab="setTab" :_event="_event" :_cbOK="cbOK")

			b-tab(title='Добавить участника в группу без создания аккаунта')
				createMemberTab(:_cbOK="cbOK" :_event="_event")

</template>

<script>
	import { mapActions, mapState } from 'vuex'

	import createAccountTab from './modalTabs/createAccountTab'
	import FormPpnt from '../../components/FormPpnt'
	import createMemberTab from './modalTabs/createMemberTab'

	let regFormModel = [
		{name:"promo_code", placeholder:"Промокод", type:"text" },
	];


	export default {
		props: ['action', 'id', '_event'],
		components: {
			FormPpnt,
			createAccountTab,
			createMemberTab,
		},
		data: () => ({
			timer: null,
			timerLoading: false,
			tabIndex: 0,
			searchStr: '',
			filteredUsers: [],
			regFormModel,
		}),
		watch: {
			searchStr(){
				if ( this.searchStr.toLowerCase() === '' ){
					this.filteredUsers = [];
					return false;
				}
				this.timerLoading = true;

				// cancel existing timer
				if ( this.task !== null ) {
					clearTimeout(this.task);
					this.task = null;
				}

				// set new timer
				this.task = setTimeout(()=>{
					this.timerLoading = false;
					this.$store.dispatch('getUserByEmail', {search:this.searchStr.toLowerCase()})
						.then(() => {
							this.filteredUsers = this.account.users.data.results;
						})
						.catch(error => {
							this.filteredUsers = [];
						});
				}, 500);

			}
		},
		computed: {
			...mapState(['account','myParticipant','page']),
		},
		methods: {
			...mapActions(['getMyParticipant']),

			setTab(n){ return this.tabIndex = n },
			cbOK(){
				this.$store.dispatch('getMyParticipant', { id:this.myParticipant.data.id });
				setTimeout(()=>{
					this.page.participant.registered = false;
					this.searchStr = '';
					this.$bvModal.hide('addExtraParticipantModal');
					this.$store.commit('clearUsersPost');
					this.$store.commit('clearMembersPost');
				},1000);
			}
		},
	}
</script>

<style>
	.custom-file-input ~ .custom-file-label::after {
		content: 'Загрузить'!important;
	}
</style>
